import React, { useEffect, useState } from "react";
import { Download } from "react-bootstrap-icons";
// import "bootstrap/dist/css/bootstrap.min.css";
import useGetStaffAttendanceReport from "../hooks/useGetStaffAttendanceReport";
import useFetchPayRoleDetails from "../hooks/useFetchPayRoleDetails";

// Custom CSS for modern styling
const styles = `
  .attendance-app {
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    // background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    min-height: 100vh;
    // padding: 100px 20px 40px;
    padding-top: 90px;
    // margin-top: 90px;
    padding-inline: 6px;
  }

  .attendance-container {
    max-width: 1200px;
    margin: 0 auto;
    background: white;
    border-radius: 20px;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
    overflow: hidden;
  }

  .attendance-header {
    // background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);
    background: #f8fafc;
    color: white;
    padding: 6px;
    position: relative;
  }

  .header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 20px;
  }

  .month-selector {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    background: rgba(255, 255, 255, 0.2);
    // padding: 12px 20px;
    border-radius: 12px;
    backdrop-filter: blur(10px);
  }

  .month-input {
    // background: transparent;
    // border: 2px solid rgba(255, 255, 255, 0.3);
    border-radius: 8px;
    padding: 8px 12px;
    // color: white;
    font-weight: 500;
    outline: none;
    transition: all 0.3s ease;
  }

  .month-input:focus {
    // border-color: rgba(255, 255, 255, 0.8);
    // box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.1);
  }

  .month-input::-webkit-calendar-picker-indicator {
    // filter: invert(1);
    cursor: pointer;
  }

  .download-btn {
    // background: rgba(255, 255, 255, 0.2);
    // border: 2px solid rgba(255, 255, 255, 0.3);
    // color: white;
    padding: 8px 12px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 600;
    transition: all 0.3s ease;
    cursor: pointer;
    text-decoration: none;
  }

  .download-btn:hover {
    // background: rgba(255, 255, 255, 0.3);
    // border-color: rgba(255, 255, 255, 0.5);
    transform: translateY(-2px);
    // color: white;
    text-decoration: none;
  }

  .calendar-section {
    padding: 6px;
  }

  .calendar-title {
    color: #1f2937;
    font-size: 1.5rem;
    font-weight: 700;
    margin-bottom: 25px;
    text-align: center;
  }

  .calendar-grid {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 8px;
    margin-bottom: 30px;
  }

  .calendar-header {
    background: #f8fafc;
    color: #64748b;
    font-weight: 600;
    padding: 15px 10px;
    text-align: center;
    border-radius: 10px;
    font-size: 0.9rem;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .calendar-cell {
    background: #f8fafc;
    border-radius: 12px;
    padding: 15px 5px;
    text-align: center;
    min-height: 80px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    transition: all 0.3s ease;
    border: 2px solid transparent;
  }

  .calendar-cell:hover {
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  }

  .calendar-day {
    font-weight: 600;
    color: #1f2937;
    margin-bottom: 5px;
    font-size: 1.1rem;
  }

  .calendar-status {
    font-size: 0.8rem;
    font-weight: 600;
    padding: 4px 8px;
    border-radius: 6px;
    text-transform: uppercase;
  }

  .status-present {
    background: #10b981;
    color: white;
  }

  .status-absent {
    background: #ef4444;
    color: white;
  }

  .status-leave {
    background: #f59e0b;
    color: white;
  }

  .status-holiday {
    background: #6b7280;
    color: white;
  }

  .status-empty {
    background: #e5e7eb;
    color: #9ca3af;
  }

  .empty-cell {
    background: transparent;
    border: 2px dashed #e5e7eb;
  }

  .loading-container {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 60px 30px;
  }

  .loading-spinner {
    width: 40px;
    height: 40px;
    border: 4px solid #e5e7eb;
    border-top: 4px solid #4f46e5;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }

  .error-message {
    background: #fee2e2;
    color: #dc2626;
    padding: 20px;
    border-radius: 12px;
    text-align: center;
    margin: 30px;
    border-left: 4px solid #dc2626;
  }

  .no-records {
    text-align: center;
    padding: 60px 30px;
    color: #6b7280;
  }

  .no-records img {
    margin-bottom: 30px;
    opacity: 0.7;
    filter: grayscale(1);
  }

  .no-records h5 {
    color: #374151;
    font-weight: 600;
    margin-bottom: 10px;
  }

  .attendance-legend {
    display: flex;
    justify-content: center;
    gap: 15px;
    flex-wrap: wrap;
    margin-top: 30px;
    padding: 20px;
    background: #f8fafc;
    border-radius: 12px;
  }

  .legend-item {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 0.9rem;
    color: #64748b;
  }

  .legend-color {
    width: 16px;
    height: 16px;
    border-radius: 4px;
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

  @media (max-width: 768px) {
    .attendance-app {
      // padding: 80px 15px 20px;
    }
    
    .header-content {
      flex-direction: column;
      align-items: stretch;
    }
    
    .month-selector {
      justify-content: center;
    }
    
    .calendar-grid {
      gap: 4px;
    }
    
    .calendar-cell {
      min-height: 60px;
      padding: 10px 2px;
    }
    
    .calendar-day {
      font-size: 0.9rem;
    }
    
    .attendance-legend {
      // flex-direction: column;
      align-items: center;
      gap: 10px;
    }
  }
`;

// Add styles to document head
const styleSheet = document.createElement("style");
styleSheet.innerText = styles;
document.head.appendChild(styleSheet);

// Calendar Component
const Calendar = ({ year, month, attendance }) => {
  const firstDay = new Date(year, month - 1, 1).getDay();
  const daysInMonth = new Date(year, month, 0).getDate();

  const calendarCells = [];

  // Empty cells for alignment
  for (let i = 0; i < firstDay; i++) {
    calendarCells.push(
      <div key={`empty-${i}`} className="calendar-cell empty-cell"></div>
    );
  }

  // All days of the month
  for (let day = 1; day <= daysInMonth; day++) {
    const dateStr = `${year}-${String(month).padStart(2, "0")}-${String(
      day
    ).padStart(2, "0")}`;
    const status = attendance?.[dateStr];

    const getStatusClass = (status) => {
      switch (status) {
        case "P":
          return "status-present";
        case "A":
          return "status-absent";
        case "L":
          return "status-leave";
        case "H":
          return "status-holiday";
        default:
          return "status-empty";
      }
    };

    calendarCells.push(
      <div key={dateStr} className="calendar-cell">
        <div className="calendar-day">{day}</div>
        <div className={`calendar-status ${getStatusClass(status)}`}>
          {status || "-"}
        </div>
      </div>
    );
  }

  // Total cells needed to fill the last week
  const totalCells = Math.ceil(calendarCells.length / 7) * 7;
  while (calendarCells.length < totalCells) {
    calendarCells.push(
      <div
        key={`pad-${calendarCells.length}`}
        className="calendar-cell empty-cell"
      ></div>
    );
  }

  return (
    <div className="calendar-section">
      <h3 className="calendar-title">
        Attendance for {year}-{String(month).padStart(2, "0")}
      </h3>

      <div className="calendar-grid">
        {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((day) => (
          <div key={day} className="calendar-header">
            {day}
          </div>
        ))}
        {calendarCells}
      </div>

      <div className="attendance-legend">
        <div className="legend-item">
          <div className="legend-color status-present"></div>
          <span>Present (P)</span>
        </div>
        <div className="legend-item">
          <div className="legend-color status-absent"></div>
          <span>Absent (A)</span>
        </div>
        <div className="legend-item">
          <div className="legend-color status-leave"></div>
          <span>Leave (L)</span>
        </div>
        <div className="legend-item">
          <div className="legend-color status-holiday"></div>
          <span>Holiday (H)</span>
        </div>
      </div>
    </div>
  );
};

// Main Exam Component
const Exam = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth() + 1;
  const currentMonth = `${year}-${String(month).padStart(2, "0")}`;

  const [selectedMonth, setSelectedMonth] = useState(currentMonth);
  const { staffAttErr, loadingStaffAtt, staffAtt, getStaffAttendanceReport } =
    useGetStaffAttendanceReport();
  const [empId] = useState(localStorage.getItem("user-id"));
  const { fetchPayRoleData } = useFetchPayRoleDetails();

  // Fetch report on month change
  useEffect(() => {
    getStaffAttendanceReport(selectedMonth, empId);
  }, [selectedMonth, empId]);

  // Extract year and month from selectedMonth string
  const [selYear, selMonth] = selectedMonth.split("-").map(Number);

  return (
    <div className="attendance-app">
      <div className="attendance-container">
        <div className="attendance-header">
          <div className="header-content">
            <div className="month-selector">
              {/* <label
                htmlFor="month-picker"
                style={{ color: "white", fontWeight: "600" }}
              >
                Select Month:
              </label> */}
              <input
                id="month-picker"
                onChange={(e) => setSelectedMonth(e.target.value)}
                value={selectedMonth}
                type="month"
                className="month-input"
              />
            </div>

            <button
              onClick={() => fetchPayRoleData(selectedMonth, empId)}
              className="download-btn "
            >
              <Download /> Download Payslip
            </button>
          </div>
        </div>

        {loadingStaffAtt && (
          <div className="loading-container">
            <div className="loading-spinner"></div>
          </div>
        )}

        {staffAttErr && (
          <div className="error-message">
            <strong>Error:</strong> {staffAttErr}
          </div>
        )}

        {Array.isArray(staffAtt) && staffAtt.length > 0 ? (
          <Calendar
            year={selYear}
            month={selMonth}
            attendance={staffAtt[0]?.attendance}
          />
        ) : (
          !loadingStaffAtt && (
            <div className="no-records">
              <img
                src="/assets/img/bg-img/icons8-date-94.png"
                width={150}
                alt="No records"
              />
              <h5>No records available for this date</h5>
              <p>Please select a different month to view attendance records</p>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default Exam;
